export default function formatCount(count) {
  if (count === 0) return "";
  if (count < 1000) return count.toString();
  if (count < 1000000)
    return (count / 1000).toFixed(count % 1000 === 0 ? 0 : 1) + "k";
  return (count / 1000000).toFixed(count % 1000000 === 0 ? 0 : 1) + "M";
}
